import React, { useState } from 'react';
import { Container, Stack, TextInput, Button, Title, Alert } from '@mantine/core';
import { adminIngestLifetimeAuto, adminIngestFullFromDefault, adminResetAndReingestFull } from '../services/adminManualIngest';

export default function AdminManualLifetimeThreads() {
  const [userID, setUserID] = useState('');
  const [llt, setLlt] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const validate = () => {
    if (!userID || !llt) {
      setErr('userID와 Long-Lived Token을 입력하세요.');
      return false;
    }
    setErr(null);
    return true;
  };

  const handleAuto = async () => {
    if (!validate()) return;
    setLoading(true);
    setMsg(null);
    try {
      const res = await adminIngestLifetimeAuto(userID, llt);
      setMsg(`자동 수집 완료: 저장 ${res.savedCount}개`);
    } catch (e) {
      setErr(e?.message || '자동 수집 실패');
    } finally {
      setLoading(false);
    }
  };

  const handleFullFromDefault = async () => {
    if (!validate()) return;
    setLoading(true);
    setMsg(null);
    try {
      const res = await adminIngestFullFromDefault(userID, llt);
      setMsg(`전체 수집(신규 가입 기준) 완료: 조회 ${res.fetched}개, 저장 ${res.saved}개`);
    } catch (e) {
      setErr(e?.message || '전체 수집 실패');
    } finally {
      setLoading(false);
    }
  };

  const handleResetAndReingest = async () => {
    if (!validate()) return;
    if (!window.confirm('정말로 이 사용자의 모든 스레드 데이터를 삭제하고 다시 수집할까요?\n이 작업은 되돌릴 수 없습니다.')) return;
    setLoading(true);
    setMsg(null);
    try {
      const res = await adminResetAndReingestFull(userID, llt);
      setMsg(`리셋 및 재수집 완료: 삭제 ${res.deletedDocs}개, 조회 ${res.fetched}개, 저장 ${res.saved}개`);
    } catch (e) {
      setErr(e?.message || '리셋 및 재수집 실패');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size="sm" pt="lg">
      <Stack gap="md">
        <Title order={3}>Manual Lifetime Threads Ingest</Title>
        {err && <Alert color="red">{err}</Alert>}
        {msg && <Alert color="green">{msg}</Alert>}

        <TextInput
          label="User ID"
          placeholder="threads user id"
          value={userID}
          onChange={(e) => setUserID(e.currentTarget.value)}
          disabled={loading}
          required
        />
        <TextInput
          label="Long-Lived Token"
          placeholder="LLT"
          value={llt}
          onChange={(e) => setLlt(e.currentTarget.value)}
          type="password"
          disabled={loading}
          required
        />

        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Button onClick={handleAuto} loading={loading}>
            자동 수집(lastUpdated 이후)
          </Button>
          <Button variant="light" onClick={handleFullFromDefault} loading={loading}>
            전체 수집(신규 가입 기준)
          </Button>
          <Button color="red" variant="outline" onClick={handleResetAndReingest} loading={loading}>
            전체 리셋 후 재수집(위험)
          </Button>
        </div>
      </Stack>
    </Container>
  );
}


